module.exports = __webpack_public_path__ + "img/detailYuboya.30f50317.png";